interface SignalLoadingStateProps {
  count?: number;
}

export const SignalLoadingState = ({ count = 6 }: SignalLoadingStateProps) => {
  return (
    <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="animate-pulse rounded-[14px] border border-[#ece8e1] bg-[#fffffe] p-6"
        >
          {/* Header: severity placeholder + toggle placeholder */}
          <div className="mb-4 flex items-center justify-between">
            <div className="h-5 w-16 rounded bg-[#f0ece6]" />
            <div className="h-5 w-9 rounded-full bg-[#f0ece6]" />
          </div>
          {/* Text lines */}
          <div className="space-y-2.5">
            <div className="h-4 w-full rounded bg-[#f0ece6]" />
            <div className="h-4 w-5/6 rounded bg-[#f0ece6]" />
            <div className="h-4 w-3/4 rounded bg-[#f0ece6]" />
          </div>
          {/* Footer */}
          <div className="mt-5 flex items-center gap-2 border-t border-[#f0ece6] pt-3">
            <div className="h-7 w-7 rounded-full bg-[#f0ece6]" />
            <div className="h-3 w-20 rounded bg-[#f0ece6]" />
            <div className="ms-auto h-3 w-12 rounded bg-[#f0ece6]" />
          </div>
        </div>
      ))}
    </div>
  );
};
